import { intersect, literal, nullable, partial, struct, union } from 'io-ts/lib/Decoder';

import { constants } from '@bedc/constants';

import { Id as ClientId } from '../../../../client/Id';
import { Id as OrganizationId } from '../../../../organization/Id';
import { Request as BaseRequest } from '../../../generic/search/Request';

export const Request = intersect(
	BaseRequest({
		sortFields: [...constants.team.sortFields] as const,
		columnFields: [...constants.team.columnFields] as const,
		standardFilterFields: ['status', 'userGroup'] as const,
		dateFilterFields: [] as const,
		stageStatusFilterFields: [] as const,
		booleanFilterFields: ['inScope'] as const,
	})
)(
	union(
		struct({
			parentType: literal('organization'),
			parentId: nullable(OrganizationId),
		}),
		struct({
			parentType: literal('client'),
			parentId: nullable(ClientId),
		}),
		partial({
			parentType: literal(null),
			parentId: literal(null),
		})
	)
);
